import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import PrivateRoute from './PrivateRoute/PrivateRoute';
import * as ROUTER_PATH_TITLE from '../../constants/ROUTER_PATH_TITLE';
import config from '../../config';
// import AppNav from '../AppNav/AppNav';
import RegisterPage from '../../pages/Register/Register';
import LoginPage from '../../pages/Login/Login';
import HomePage from '../../pages/Home/Home';
// import TravelGuidePage from '../../pages/TravelGuide/TravelGuide';
import TripPlanPage from '../../pages/TripPlan/TripPlan';
/* import ToursPage from '../../pages/Tours/Tours'; */
/* import GygToursPage from '../../pages/GygTours/GygTours'; */
import CreateTripPage from '../../pages/CreateUpdateTrip/CreateTrip';
import UpdateTripPage from '../../pages/CreateUpdateTrip2/UpdateTrip';
import NotFoundPage from '../../pages/NotFound/NotFound';
import UserProfilePage from '../../pages/UserProfile/UserProfile';
import UseTripUrlPage from '../../pages/UseTripUrl/UseTripUrl';
import LoginWithHashPage from '../../pages/LoginWithHash/LoginWithHash';
import PlaceInfoPage from '../../pages/PlaceInfo/PlaceInfo';
import TourInfoPage from '../../pages/TourInfo/TourInfo';
import TravelCompanions from '../../pages/TravelCompanions/TravelCompanions';
import OverviewPage from '../../pages/Overview/Overview';
// import CityPage from '../../pages/City/City.txt';

const AppRouter = () => (
  <Router basename={config.ROUTER_BASE_NAME}>
    {/* <AppNav /> */}
    <Switch>
      <Route path={ROUTER_PATH_TITLE.REGISTER.PATH} exact component={RegisterPage} />
      <Route path={ROUTER_PATH_TITLE.LOGIN.PATH} exact component={LoginPage} />
      <Route path={ROUTER_PATH_TITLE.LOGIN_WITH_HASH.PATH} exact component={LoginWithHashPage} />
      <PrivateRoute path={ROUTER_PATH_TITLE.USER_PROFILE.PATH} exact component={UserProfilePage} />
      <PrivateRoute path={ROUTER_PATH_TITLE.HOME.PATH} exact component={HomePage} />
      <PrivateRoute path={ROUTER_PATH_TITLE.CREATE_TRIP.PATH} exact component={CreateTripPage} />
      <PrivateRoute path={`${ROUTER_PATH_TITLE.UPDATE_TRIP.PATH}/:hash`} exact component={UpdateTripPage} />
      <PrivateRoute path={`${ROUTER_PATH_TITLE.TRIP_PLAN.PATH}/:hash`} exact component={TripPlanPage} />
      {/* <PrivateRoute path={`${ROUTER_PATH_TITLE.TRAVEL_GUIDE.PATH}/:hash`} exact component={TravelGuidePage} /> */}
      <PrivateRoute path={`${ROUTER_PATH_TITLE.OVERVIEW.PATH}/:hash`} exact component={OverviewPage} />
      {/* <PrivateRoute path={`${ROUTER_PATH_TITLE.TOURS.PATH}/:hash`} exact component={ToursPage} /> */}
      {/* <PrivateRoute path={`${ROUTER_PATH_TITLE.GYGTOURS.PATH}/:hash`} exact component={GygToursPage} /> */}
      <PrivateRoute path={`${ROUTER_PATH_TITLE.TRAVEL_COMPANIONS.PATH}`} exact component={TravelCompanions} />
      <Route path={`${ROUTER_PATH_TITLE.PLACE_INFO.PATH}/:id`} component={PlaceInfoPage} />
      <Route path={`${ROUTER_PATH_TITLE.TOUR_INFO.PATH}/:id`} component={TourInfoPage} />
      {/* <Route path={`${ROUTER_PATH_TITLE.CITY.PATH}/:id`} component={CityPage} /> */}
      <Route path={ROUTER_PATH_TITLE.USE_TRIP_URL.PATH} component={UseTripUrlPage} />
      <Route path={ROUTER_PATH_TITLE.NOT_FOUND.PATH} component={NotFoundPage} />
    </Switch>
  </Router>
);

export default AppRouter;
